export default "__VITE_ASSET__CtDHOQKG__";